module.exports = __webpack_public_path__ + "85dce0ab127539d8bc6ae4809e5affbb.jpg";